import { CLAIM_CORRECTION_URL } from "../../util/constants/api.constants";

import api from "../../util/api";

export function getClaimsData(url : string, params : any) {
    return api.get(url, params);
}
export function getClaimCorrectionStatuslookupData(url: string) {
    return api.get(url, {});
}

export function updateClaimsData(payload: any, params : any) {
    let url = `${CLAIM_CORRECTION_URL.UPDATE_CLAIM}/${params}`;
    return api.put(url, payload);
}

export function getUserRole(url : string, params : any) {
    return api.get(url, params);
}

export function validateProcedureCode(url: string, claimId: number, procedureCodes: string[]) {
    return api.post(url, { claimId, procedureCodes });
}

export function validateDiagnosisCode(url: string, claimId: number, diagnosisCode: string) {
    return api.post(url, { claimId, diagnosisCode });
  }

export function getCarrierList(url : string, params : any) {
    return api.get(url, params);
}

export function getICDCodesAutocomplete(searchTerm: string) {
    let url = `${CLAIM_CORRECTION_URL.ICDCODES}?searchTerm=${encodeURIComponent(searchTerm)}`;
    return api.get(url, {});
}
export function getProcedureCodesAutocomplete(searchTerm: string) {
    let url = `${CLAIM_CORRECTION_URL.PROCEDURECODE}?searchTerm=${encodeURIComponent(searchTerm)}`;
    return api.get(url, {});
}
export function getDashboardMetrics(params : any) {
    return api.get(CLAIM_CORRECTION_URL.DASHBOARD_METRICS, params);
}
export function getCCTUserDataTableFromDB(params : any, email : string) {
    let url = `${CLAIM_CORRECTION_URL.GET_UAER_STORAGE_PREFERENCE}/${email}`;
    return api.get(url, params);
}

export function updateCCTUserDataTableFromDB(payload: any) {
    let url = `${CLAIM_CORRECTION_URL.UPDATE_UAER_STORAGE_PREFERENCE}`;
    return api.post(url, payload);
}